import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { baseUrlAdmin } from '../../store/apiConstants';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';

class BranchToSectionDD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardId: null,
            classId: null,
            groupId: null,
            branchId: null,
            sectionId: null,
            boards: [],
            classes: [],
            curriculumInfo: {},
        };
        this.service = new Service()
    }

    componentDidMount() {
        this.getData()
    }

    componentDidUpdate() {
        if (this.props && (this.props?.defaultDDValues !== undefined && this.props?.defaultDDValues !== null)) {
            const { branchId, boardId, classId, sectionId } = this.props.defaultDDValues


            if (branchId.length && boardId.length && classId.length && sectionId.length) {
                if (this.state.boardId == null && this.state.classId == null && this.state.branchId == null && this.state.sectionId == null) {

                    // Use filtered boards based on selected branch and user role
                    let filteredBoards = this.getFilteredBoards(branchId);
                    const selectedBoard = filteredBoards && filteredBoards.find((board) => board.boardId === boardId);
                    let selectedClass = selectedBoard?.classes?.find((classd) => classd.classId == classId)

                    let filteredSections = selectedClass?.sections?.filter((sec) => sec.branchId == branchId)

                    // Apply teacher-specific filtering to sections
                    filteredSections = this.getFilteredSections(filteredSections);

                    this.setState({
                        boardId: boardId,
                        classId: classId,
                        branchId: branchId,
                        sectionId: sectionId,
                        boards: filteredBoards,
                        classes: selectedBoard.classes,
                        sections: filteredSections
                    }, () => this.state?.sectionId && this.setDropdownsData())


                }
            }

        }


    }

    getData = () => {
        /*  this.props.getBranchesLatest();
         this.props.getBoardsData(true) */
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');

        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }

        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );

        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchId) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = boards.filter(board =>
            board.assignedBranches.includes(selectedBranchId)
        );

        // If user is admin, return all boards (filtered only by selected branch)
        if (userInfo?.isAdmin === true) {
            // Already filtered by selected branch above
            return this.removeDuplicates(filteredBoards, 'boardId');
        }

        // For teachers, additionally filter by assigned boards
        if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }
        // For non-admin, non-teacher users, filter by assigned boards if available
        else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }

        // Remove duplicate boards by boardId
        return this.removeDuplicates(filteredBoards, 'boardId');
    }

    // Filter sections based on user role
    getFilteredSections = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If not a teacher, return all sections (no filtering needed)
        if (!this.isTeacher()) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If teacher but no assignedSections, return empty array (no sections accessible)
        if (!userInfo?.sections || userInfo.sections.length === 0) {
            return [];
        }

        // For teachers with assignedSections, filter by assigned sections
        const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
        
        return this.removeDuplicates(filtered, 'sectionId');
    }

    onChangeBranch = (branchId) => {
        this.setState({
            boards: [], classes: [], sections: [],
        });
        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;

        // Use filtered boards based on selected branch and user role
        let filteredBoards = this.getFilteredBoards(branchId);

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: filteredBoards,
            classes: [],
            boardId: '',
            selectedBoardName: '',
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            sections: [],
            sectionId: '',
            selectedsectionName: '',
            selectedSectionMaxStrength: 0,
            selectedSectionAssignedStudents: 0
        });
    };

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [], sections: [],
        });
        const selectedBoard = this.state.boards && this.props.boards.find((board) => board.boardId === boardId);

        this.setState({
            classes: selectedBoard?.classes,
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            sections: [],
            sectionId: '',
            selectedsectionName: '',
            selectedSectionMaxStrength: 0,
            selectedSectionAssignedStudents: 0

        }, () => this.setDropdownsData());
    };

    onChangeClass = (classId) => {
        let selectedClass = this.state.classes?.find((classd) => classd.classId == classId)

        let filteredSections = selectedClass?.sections.filter((sec) => sec.branchId == this.state.branchId)

        // Apply teacher-specific filtering to sections
        filteredSections = this.getFilteredSections(filteredSections);

        this.setState({
            classId: classId,
            selectedClass: selectedClass,
            branches: selectedClass?.branches,
            selectedClassName: selectedClass?.className,
            sections: filteredSections,
            sectionId: '',
            selectedsectionName: '',
            selectedSectionMaxStrength: 0,
            selectedSectionAssignedStudents: 0
        }, () => this.setDropdownsData());
    };

    onChangeSection = (sectionId) => {
        let selectedSection = this.state.sections?.find((sectiond) => sectiond.sectionId == sectionId);
        //let selectedsectionName = this.state.sections?.find((sectiond) => sectiond.sectionId == sectionId).sectionName;

        this.setState({
            sectionId: sectionId,
            selectedsectionName: selectedSection?.sectionName,
            selectedSectionMaxStrength: selectedSection?.maxStrength,
            selectedSectionAssignedStudents: selectedSection?.assignedStrength,
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardId,
            classId,
            branchId,
            sectionId,
            selectedBoardName,
            selectedClassName, selectedbranchName, selectedsectionName, selectedSectionMaxStrength, selectedSectionAssignedStudents
        } = this.state
        let returnData = {
            boardId, classId, branchId, sectionId, selectedBoardName,
            selectedClassName, selectedbranchName, selectedsectionName, selectedSectionMaxStrength, selectedSectionAssignedStudents
        }
        this.props.setValues(returnData)
    }



    render() {
        // Get filtered branches for the dropdown options
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div >
                    <div className='grid m-2'>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Branch'}
                                // /* icon={<BoardsIconInActive height={16.5} width={19.5} />} */
                                placeholder={'Select Branch'} options={filteredBranchData}
                                value={this.state.branchId} onChange={(e) => this.onChangeBranch(e.value)} optionLabel="name"
                                optionValue="key" />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Board'}
                                // /* icon={<BoardsIconInActive height={16.5} width={19.5} />} */
                                placeholder={'Select Board'} options={this.state.boards} value={this.state.boardId} onChange={(e) => this.onChangeBoard(e.value)} optionLabel="boardName"
                                optionValue="boardId" />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Grade'}
                                // /*  icon={<GradesIcon />} */ 
                                placeholder={'Select Grade'} options={this.state?.classes}
                                value={this.state.classId} onChange={(e) => this.onChangeClass(e.value)} optionLabel="className"
                                optionValue="classId" />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown required={true} label={'Section'}
                                // /*  icon={<GradesIcon />} */
                                placeholder={'Select Section'} options={this.state?.sections}
                                value={this.state.sectionId} onChange={(e) => this.onChangeSection(e.value)} optionLabel="sectionName"
                                optionValue="sectionId" />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    // boards: state.boardsData.boards,
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToSectionDD);